export default "<p>input-std-sku works!</p>\r\n"